<div class="col-12 n-padding" *ngIf="eventTriggered">
  <!-- Credit Radio Buttons -->
  <p class="lead m-t-lg text-bold">{{ creditConfigurableData?.credit }}</p>

  <div class="form-label m-t-md">
    <tmo-radio-button
      name="co-radio_sample"
      class="checked"
      type="radio"
      [values]="'EXCELLENT_CREDIT'"
      [selectedValue]="selectedCreditLevel"
      (click)="setCreditLevel('EXCELLENT_CREDIT')"
      aria-label="Radio"
      [id]="'tmo-radio-button-coradiosample-3'"
    >
      <p class="content">{{ creditConfigurableData?.excellentCredit }}</p>
      <p class="small content">{{ creditConfigurableData?.creditHistory }}</p>
    </tmo-radio-button>
  </div>

  <div class="form-label m-t-md">
    <tmo-radio-button
      name="co-radio_sample"
      type="radio"
      [values]="'AVERAGE_CREDIT'"
      [selectedValue]="selectedCreditLevel"
      (click)="setCreditLevel('AVERAGE_CREDIT')"
      aria-label="Radio"
      [id]="'tmo-radio-button-coradiosample-4'"
    >
      <p class="content">{{ creditConfigurableData?.averageCredit }}</p>
      <p class="small content">{{ creditConfigurableData?.creditProblems }}</p>
    </tmo-radio-button>
  </div>

  <div class="form-label m-t-md">
    <tmo-radio-button
      name="co-radio_sample"
      type="radio"
      [values]="'BUILDING_CREDIT'"
      [selectedValue]="selectedCreditLevel"
      (click)="setCreditLevel('BUILDING_CREDIT')"
      aria-label="Radio"
      [id]="'tmo-radio-button-coradiosample-5'"
    >
      <p class="content">{{ creditConfigurableData?.buildingCredit }}</p>
      <p class="small content">{{ creditConfigurableData?.buildCreditDescription }}</p>
    </tmo-radio-button>
  </div>
</div>
